import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheck, FiArrowRight, FiLoader } = FiIcons;

export function SectionHeading({ eyebrow, title, text, align = 'center' }) {
  return (
    <div className={`section-heading ${align}`}>
      {eyebrow && <span className="eyebrow">{eyebrow}</span>}
      <h2>{title}</h2>
      {text && <p>{text}</p>}
    </div>
  );
}

export function FeatureCard({ icon, title, text }) {
  return (
    <article className="card feature-card">
      <span className="feature-icon"><SafeIcon icon={icon} /></span>
      <h3>{title}</h3>
      <p>{text}</p>
    </article>
  );
}

export function PlanCard({ plan, onChoose, loading }) {
  const features = plan.features || [];
  return (
    <article className={`card plan-card ${plan.featured ? 'featured' : ''}`}>
      {plan.featured && <span className="plan-label">Best Value</span>}
      <h3>{plan.name}</h3>
      <p>{plan.description}</p>
      <div className="price">
        {plan.price_amount ? <><strong>{plan.currency} {plan.price_amount}</strong><span>/{plan.interval}</span></> : <strong>Custom pricing</strong>}
      </div>
      <ul className="check-list">
        {features.map((feature) => <li key={feature}><SafeIcon icon={FiCheck} />{feature}</li>)}
      </ul>
      <button className="button full" onClick={() => onChoose(plan)} disabled={loading}>
        {loading ? <SafeIcon icon={FiLoader} className="spin" /> : plan.price_amount ? 'Choose Plan' : 'Request Corporate Proposal'}
        {!loading && <SafeIcon icon={FiArrowRight} />}
      </button>
    </article>
  );
}

export function Notice({ type = 'info', children }) {
  return <div className={`notice ${type}`} role="status">{children}</div>;
}